import './Footer.css';

const Footer = () => {
  return (
    <footer className="section footer">
      <div className="container">
        <div className="footer-container">
          <div className="footer-center">
            <h3>ABOUT PET FOOD</h3>
            <div><span>Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt</span></div>
          </div>
          <div className="footer-center">
            <h3>DOG HEALTH</h3>
            <div><span>Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt</span></div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
